import { css } from "@emotion/react"
import { Skeleton } from "source/shared/components/Skeleton"

export default function LoadingState() {
  return (
    <div css={styles.wrapper}>
      <div css={styles.header}>
        <Skeleton height="24px" width="50%" />
        <Skeleton height="14px" width="90%" />
        <Skeleton height="14px" width="70%" />
      </div>

      <div css={styles.playerCard}>
        <div css={styles.row}>
          <div css={styles.leftColumn}>
            <Skeleton height="220px" />
          </div>
          <div css={styles.rightColumn}>
            <div css={styles.episodeList}>
              <Skeleton height="68px" />
              <Skeleton height="68px" />
              <Skeleton height="68px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const styles = {
  wrapper: css`
    container-type: inline-size;
  `,
  header: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
  `,
  playerCard: css`
    overflow: hidden;
  `,
  row: css`
    display: grid;
    grid-template-columns: 1fr;

    @container (min-width: 500px) {
      grid-template-columns: 1fr 1fr;
    }
  `,
  leftColumn: css`
    display: flex;
    flex-direction: column;
  `,
  rightColumn: css`
    max-height: 250px;
    overflow-y: auto;

    @container (min-width: 500px) {
      position: relative;
      max-height: none;
      overflow: hidden;

      > * {
        position: absolute;
        inset: 0;
        overflow-y: auto;
      }
    }
  `,
  episodeList: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
  `,
}
